// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { FirstName, FirstNameSchema } from 'api/gen/FirstName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Language, LanguageSchema } from 'api/gen/Language';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { LastName, LastNameSchema } from 'api/gen/LastName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  firstName: t.union([FirstNameSchema, t.null]),
  language: LanguageSchema,
  lastName: t.union([LastNameSchema, t.null]),
  permissions: t.union([t.array(t.string), t.null]),
  userProfileId: PositiveIntegerSchema,
  username: UsernameSchema,
});

export const PrincipalSchema = excess(requiredPart);

export interface Principal extends t.TypeOf<typeof PrincipalSchema> {}
